<!-- ============================================================== -->
<!-- Login Page - Rediseño Moderno (Facturador) -->
<!-- ============================================================== -->
<div class="login-root">

  <!-- Panel Izquierdo: Ilustración decorativa -->
  <div class="login-left-panel">
    <div class="login-left-inner">

      <!-- Decoración de puntos de fondo -->
      <div class="decor-dots">
        <span class="dot dot-1"></span>
        <span class="dot dot-2"></span>
        <span class="dot dot-3"></span>
        <span class="dot dot-4"></span>
        <span class="dot dot-5"></span>
        <span class="dot dot-6"></span>
      </div>

      <!-- Ilustración central: mockup de factura -->
      <div class="illustration-wrapper" (mouseenter)="pauseCarousel()" (mouseleave)="resumeCarousel()">

        <!-- Tarjeta principal – contenido dinámico por escena -->
        <div class="mock-card mock-card-main" [class.scene-exiting]="isTransitioning">

          <!-- Escena 0: Factura Electrónica -->
          <div *ngIf="activeScene === 0 && !isTransitioning" class="scene-content">
            <div class="mock-card-header">
              <div class="mock-icon-box">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#4f7df3" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="3" y="3" width="18" height="18" rx="3"/>
                  <line x1="8" y1="9" x2="16" y2="9"/>
                  <line x1="8" y1="13" x2="14" y2="13"/>
                  <line x1="8" y1="17" x2="12" y2="17"/>
                </svg>
              </div>
              <span class="mock-title">Factura Electrónica</span>
            </div>
            <div class="mock-table">
              <div class="mock-table-head">
                <span>Producto</span><span>Cantidad</span><span>Precio</span><span>Total</span>
              </div>
              <div class="mock-table-row"><span class="mock-bar w80"></span><span class="mock-bar w30"></span><span class="mock-bar w40"></span><span class="mock-bar w50"></span></div>
              <div class="mock-table-row"><span class="mock-bar w60"></span><span class="mock-bar w30"></span><span class="mock-bar w40"></span><span class="mock-bar w50"></span></div>
              <div class="mock-table-row"><span class="mock-bar w70"></span><span class="mock-bar w30"></span><span class="mock-bar w40"></span><span class="mock-bar w50"></span></div>
            </div>
            <div class="mock-total-row">
              <span class="mock-total-label">Total</span>
              <span class="mock-total-value">S/ 1,250.00</span>
            </div>
            <div class="mock-badge mock-badge-green">
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#27ae60" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              Emitida
            </div>
          </div>

          <!-- Escena 1: Boleta de Venta -->
          <div *ngIf="activeScene === 1 && !isTransitioning" class="scene-content">
            <div class="mock-card-header">
              <div class="mock-icon-box mock-icon-blue">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#4f7df3" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
                  <line x1="3" y1="6" x2="21" y2="6"/>
                  <path d="M16 10a4 4 0 0 1-8 0"/>
                </svg>
              </div>
              <span class="mock-title">Boleta de Venta</span>
            </div>
            <div class="mock-table">
              <div class="mock-table-head">
                <span>Producto</span><span>Cantidad</span><span>Precio</span><span>Total</span>
              </div>
              <div class="mock-table-row"><span class="mock-bar w80"></span><span class="mock-bar w30"></span><span class="mock-bar w40"></span><span class="mock-bar w50"></span></div>
              <div class="mock-table-row"><span class="mock-bar w50"></span><span class="mock-bar w30"></span><span class="mock-bar w40"></span><span class="mock-bar w60"></span></div>
            </div>
            <div class="mock-total-row">
              <span class="mock-total-label">Total</span>
              <span class="mock-total-value mock-total-blue">S/ 450.00</span>
            </div>
            <div class="mock-badge mock-badge-blue">
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#4f7df3" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
              Enviada
            </div>
          </div>

          <!-- Escena 2: Nota de Crédito -->
          <div *ngIf="activeScene === 2 && !isTransitioning" class="scene-content">
            <div class="mock-card-header">
              <div class="mock-icon-box mock-icon-orange">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#e67e22" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="1 4 1 10 7 10"/>
                  <path d="M3.51 15a9 9 0 1 0 .49-3.51"/>
                </svg>
              </div>
              <span class="mock-title">Nota de Crédito</span>
            </div>
            <div class="mock-table">
              <div class="mock-table-head">
                <span>Producto</span><span>Cantidad</span><span>Precio</span><span>Total</span>
              </div>
              <div class="mock-table-row"><span class="mock-bar mock-bar-orange w70"></span><span class="mock-bar w30"></span><span class="mock-bar w40"></span><span class="mock-bar mock-bar-orange w50"></span></div>
              <div class="mock-table-row"><span class="mock-bar mock-bar-orange w50"></span><span class="mock-bar w30"></span><span class="mock-bar w40"></span><span class="mock-bar mock-bar-orange w40"></span></div>
            </div>
            <div class="mock-total-row">
              <span class="mock-total-label">Monto</span>
              <span class="mock-total-value mock-total-orange">-S/ 180.00</span>
            </div>
            <div class="mock-badge mock-badge-orange">
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#e67e22" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-3.51"/></svg>
              Procesada
            </div>
          </div>

          <!-- Escena 3: Reporte Mensual -->
          <div *ngIf="activeScene === 3 && !isTransitioning" class="scene-content">
            <div class="mock-card-header">
              <div class="mock-icon-box mock-icon-purple">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9b59b6" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                  <line x1="18" y1="20" x2="18" y2="10"/>
                  <line x1="12" y1="20" x2="12" y2="4"/>
                  <line x1="6" y1="20" x2="6" y2="14"/>
                </svg>
              </div>
              <span class="mock-title">Reporte Mensual</span>
            </div>
            <div class="mock-chart">
              <div class="chart-bars-wrap">
                <div class="chart-bar-item"><div class="chart-bar-fill" style="height:55%"></div><span class="chart-bar-label">Ene</span></div>
                <div class="chart-bar-item"><div class="chart-bar-fill" style="height:72%"></div><span class="chart-bar-label">Feb</span></div>
                <div class="chart-bar-item"><div class="chart-bar-fill" style="height:43%"></div><span class="chart-bar-label">Mar</span></div>
                <div class="chart-bar-item"><div class="chart-bar-fill" style="height:88%"></div><span class="chart-bar-label">Abr</span></div>
                <div class="chart-bar-item"><div class="chart-bar-fill chart-bar-active" style="height:100%"></div><span class="chart-bar-label">May</span></div>
              </div>
            </div>
            <div class="mock-total-row">
              <span class="mock-total-label">Documentos</span>
              <span class="mock-total-value mock-total-purple">4,320</span>
            </div>
            <div class="mock-badge mock-badge-purple">
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#9b59b6" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>
              Actualizado
            </div>
          </div>

        </div>

        <!-- Tarjeta flotante: analytics -->
        <div class="mock-card mock-card-analytics">
          <div class="mock-analytics-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#4f7df3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
            </svg>
          </div>
        </div>

        <!-- Tarjeta flotante: check -->
        <div class="mock-card mock-card-check">
          <div class="mock-check-circle">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#4f7df3" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
          </div>
        </div>

        <!-- Tarjeta flotante: documento -->
        <div class="mock-card mock-card-doc">
          <div class="mock-doc-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#4f7df3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
              <polyline points="14 2 14 8 20 8"/>
            </svg>
          </div>
        </div>

        <!-- Líneas de conexión SVG decorativas -->
        <svg class="connector-lines" viewBox="0 0 340 320" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M 60 80 Q 30 160 60 240" stroke="#4f7df3" stroke-width="1.5" stroke-dasharray="6 5" opacity="0.3"/>
          <path d="M 280 60 Q 310 160 280 260" stroke="#4f7df3" stroke-width="1.5" stroke-dasharray="6 5" opacity="0.3"/>
          <ellipse cx="170" cy="160" rx="100" ry="120" stroke="#4f7df3" stroke-width="1" stroke-dasharray="5 6" opacity="0.18"/>
        </svg>
      </div>

      <!-- Indicadores de carrusel interactivos -->
      <div class="carousel-dots">
        <span *ngFor="let s of scenes; let i = index"
              class="cdot"
              [class.cdot-active]="i === activeScene"
              (click)="goToScene(i)"
              role="button"
              [attr.aria-label]="s.label">
        </span>
      </div>
    </div>
  </div>

  <!-- Panel Derecho: Formulario de login -->
  <div class="login-right-panel">
    <div class="login-form-wrapper">

      <!-- Logo y marca -->
      <div class="brand-header">
        <div class="brand-icon">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#4f7df3" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="3" width="18" height="18" rx="3"/>
            <line x1="8" y1="9" x2="16" y2="9"/>
            <line x1="8" y1="13" x2="14" y2="13"/>
            <line x1="8" y1="17" x2="12" y2="17"/>
          </svg>
        </div>
        <span class="brand-name">Facturador</span>
      </div>
      <p class="brand-subtitle">Tu sistema de facturación electrónica</p>

      <!-- Título de bienvenida -->
      <h1 class="welcome-title">Bienvenido de nuevo</h1>
      <p class="welcome-sub">Inicia sesión para continuar</p>

      <!-- Formulario -->
      <form ngNativeValidate #f="ngForm" class="login-form" (ngSubmit)="ingresar(f)">

        <!-- Campo Usuario -->
        <div class="field-group">
          <div class="field-input-wrap">
            <span class="field-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9aa3b5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                <circle cx="12" cy="7" r="4"/>
              </svg>
            </span>
            <input
              type="text"
              id="login-username"
              class="field-input"
              placeholder="Usuario"
              [ngModel]="username"
              name="username"
              required
              autocomplete="username">
          </div>
        </div>

        <!-- Campo Contraseña -->
        <div class="field-group">
          <div class="field-input-wrap">
            <span class="field-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9aa3b5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
              </svg>
            </span>
            <input
              [type]="showPassword ? 'text' : 'password'"
              id="login-password"
              class="field-input"
              placeholder="Contraseña"
              [ngModel]
              name="password"
              required
              autocomplete="current-password">
            <button type="button" class="field-eye-btn" (click)="showPassword = !showPassword" tabindex="-1">
              <svg *ngIf="!showPassword" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9aa3b5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                <circle cx="12" cy="12" r="3"/>
              </svg>
              <svg *ngIf="showPassword" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9aa3b5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                <line x1="1" y1="1" x2="23" y2="23"/>
              </svg>
            </button>
          </div>
        </div>

        <!-- Recordarme -->
        <div class="remember-row">
          <label class="remember-label">
            <input type="checkbox" id="login-remember" name="recuerdame" [ngModel]="recuerdame" class="remember-check">
            <span class="remember-custom"></span>
            <span class="remember-text">Recordarme</span>
          </label>
          <a routerLink="/resetPass" class="remember-text" style="margin-left: auto;">¿Olvidaste tu contraseña?</a>
        </div>

        <!-- Botón de ingreso -->
        <button
          type="submit"
          class="btn-login"
          [disabled]="loadRegister"
          id="btn-login-submit">
          <span *ngIf="loadRegister" class="btn-spinner">
            <i class="fa fa-spin fa-spinner"></i>
          </span>
          <span *ngIf="!loadRegister">Iniciar sesión</span>
          <span *ngIf="loadRegister">Verificando...</span>
          <svg *ngIf="!loadRegister" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="btn-arrow">
            <line x1="5" y1="12" x2="19" y2="12"/>
            <polyline points="12 5 19 12 12 19"/>
          </svg>
        </button>

      </form>
    </div>
  </div>

</div>
